import React, { FC } from 'react'
import { Tag } from '@wmgtech/legato'

import { FilterSelectionPillProps } from './FilterSelection.props'

const FilterSelectionPill: FC<FilterSelectionPillProps> = ({ pillName, onReset }) => (
  <Tag
    className="filter-selection-tag"
    colorType="dark"
    containerStyle="tint"
    size="xs"
    text={pillName}
    onClickIcon={onReset}
  />
)

export default FilterSelectionPill
